import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/enum/ToasterMessages';
import { ClientService } from 'src/app/shared/services/client.service';

@Component({
  selector: 'legal-add-schedule-registration',
  templateUrl: './schedule-registration.component.html',
  styleUrls: ['./schedule-registration.component.scss']
})
export class ScheduleRegistrationComponent implements OnInit, AfterViewInit {

  registerForm!: FormGroup;
  submitted = false;

  clientServiceId!: string;

  @Output()
  closeModal = new EventEmitter<boolean>();

  constructor(
    private formBuilder: FormBuilder,
    private activeRoute: ActivatedRoute,
    private toasterService: ToastrService,
    private clientService: ClientService
  ) { }

  ngOnInit(): void {
    this.clientServiceId =
      this.activeRoute.snapshot.params['id2'];

    this.initializeForm();
  }

  ngAfterViewInit(): void {
  }

  get f() {
    return this.registerForm.controls;
  }

  private initializeForm(): void {
    const now = new Date();

    const scheduledDate = `${now.getFullYear()}-${
      String(now.getMonth() + 1).padStart(2, '0')
    }-${
      String(now.getDate()).padStart(2, '0')
    }T10:00`;

    this.registerForm = this.formBuilder.group({
      scheduledDate: ['', Validators.required],
      amount: [0, Validators.required],
      haveli: [0, Validators.required],
      time: ['', Validators.required]

    });
  }

  register(): void {

    this.submitted = true;

    if (this.registerForm.invalid) {
      return;
    }

    const requestBody = {
      id: 0,
      scheduledDate:
        `${this.registerForm.value.scheduledDate}T${this.registerForm.value.time}`,
      timeSlot:'30',
      amount:
        Number(this.registerForm.value.amount),
      clientServiceId:
        this.clientServiceId,
          haveli:
        this.registerForm.value.haveli,
    };

    this.scheduleRegistration(requestBody);
  }

  private scheduleRegistration(request: any): void {

    this.clientService
      .ScheduelRegistration(request)
      .subscribe({
        next: () => {

          this.toasterService.success(
            `Registration ${ToasterMessages.Create}`,
            ToasterMessages.SucccessTitle
          );

          this.closeModal.emit(true);
        },

        error: (error) => {

          console.error(error);

          this.toasterService.error(
            error?.error?.message ||
            'Something went wrong',
            ToasterMessages.ErrorTitle
          );
        }
      });
  }

  closePopup(): void {
    this.closeModal.emit(true);
  }
}